import { Modal, Skeleton } from "antd";
import { useUsuario } from "../hooks/useUsuario";
import {
  ContainerUsuario,
  SubTitleUsuario,
  TextUsuario,
  TitleUsuario,
} from "../styles";

export default function ModalUsuario({
  isModalOpen,
  handleFechar,
  origemApto,
}: any) {
  const { isLoading, usuario } = useUsuario(origemApto, isModalOpen);

  return (
    <>
      <Modal open={isModalOpen} onCancel={handleFechar} footer={null}>
        {isLoading && <Skeleton active />}
        {!isLoading && usuario && (
          <ContainerUsuario>
            <TitleUsuario> Usuário</TitleUsuario>
            <SubTitleUsuario>
              Nome:{" "}
              <TextUsuario>
                {usuario?.nome} {usuario?.sobrenome}
              </TextUsuario>
            </SubTitleUsuario>
            <SubTitleUsuario>
              CPF: <TextUsuario>{usuario?.cpf}</TextUsuario>
            </SubTitleUsuario>
            <SubTitleUsuario>
              E-mail: <TextUsuario>{usuario?.email}</TextUsuario>
            </SubTitleUsuario>
            <SubTitleUsuario>
              Estado Cívil:
              <TextUsuario>
                {usuario?.estadoCivil &&
                  usuario.estadoCivil.charAt(0).toUpperCase() +
                    usuario.estadoCivil.slice(1).toLowerCase()}
              </TextUsuario>
            </SubTitleUsuario>
            <SubTitleUsuario>
              Telefone: <TextUsuario>{usuario?.celular}</TextUsuario>
            </SubTitleUsuario>
          </ContainerUsuario>
        )}
      </Modal>
    </>
  );
}
